import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white md:px-8 py-6 shadow rounded-lg sm:px-4 relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h6", { class: "font-bold text-center mb-4" }, "Cek Transaksi Berangkat", -1)
const _hoisted_3 = { class: "flex items-center mb-6 w-full flex-wrap search-action" }
const _hoisted_4 = { class: "flex items-center flex-1 lg:mr-3 md:mr-3 mr-0 mt-1 flex-wrap lg:w-auto md:w-auto w-full" }
const _hoisted_5 = { class: "w-full md:w-auto lg:w-auto text-right mt-2 md:mt-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex items-center px-4" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-search text-white font-medium mr-2" }),
  /*#__PURE__*/_createVNode("p", { class: "text-white font-bold" }, "Cari")
], -1)
const _hoisted_7 = {
  key: 0,
  class: "result-search lg:px-0 md:px-0 px-4"
}
const _hoisted_8 = { class: "font-bold color-blue-grey text-sm mb-3" }
const _hoisted_9 = {
  key: 1,
  class: "result-search"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "font-medium color-blue-grey text-base text-center" }, "Data tidak ditemukan", -1)
const _hoisted_11 = { class: "absolute left-4 top-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("path", {
  d: "M232 48v40a8 8 0 0 1-16 0V56h-32a8 8 0 0 1 0-16h40a8 8 0 0 1 8 8zM72 200H40v-32a8 8 0 0 0-16 0v40a8 8 0 0 0 8 8h40a8 8 0 0 0 0-16zm152-40a8 8 0 0 0-8 8v32h-32a8 8 0 0 0 0 16h40a8 8 0 0 0 8-8v-40a8 8 0 0 0-8-8zM32 96a8 8 0 0 0 8-8V56h32a8 8 0 0 0 0-16H32a8 8 0 0 0-8 8v40a8 8 0 0 0 8 8zm48-16a8 8 0 0 0-8 8v80a8 8 0 0 0 16 0V88a8 8 0 0 0-8-8zm104 88V88a8 8 0 0 0-16 0v80a8 8 0 0 0 16 0zm-40-88a8 8 0 0 0-8 8v80a8 8 0 0 0 16 0V88a8 8 0 0 0-8-8zm-32 0a8 8 0 0 0-8 8v80a8 8 0 0 0 16 0V88a8 8 0 0 0-8-8z",
  fill: "#626262"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_ItemReceiptCard = _resolveComponent("ItemReceiptCard")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Paginator = _resolveComponent("Paginator")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          id: "optionId",
          modelValue: _ctx.option,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.option = $event)),
          options: _ctx.listOption,
          onChange: _ctx.onChangeOption,
          class: "dropdown-grey flex-shrink-0 text-sm w-1/3 sm:w-auto m-0",
          optionLabel: "name",
          optionValue: "id",
          placeholder: "No.Resi",
          style: {"height":"41px"}
        }, null, 8, ["modelValue", "options", "onChange"]),
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: _ctx.inputSearch,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
          onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.submitSearch(_ctx.inputSearch)), ["enter"])),
          class: "none-left-radius flex-1 input-grey w-2/3 sm:w-auto m-0 ",
          style: {"border":"none !important"}
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "btn-primary p-button-sm rounded-md sm:ml-auto",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitSearch(_ctx.inputSearch)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.data.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("p", _hoisted_8, _toDisplayString(_ctx.filters.totalRecords) + " Transaksi Ditemukan", 1),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "mb-2",
              key: 'item-' + index
            }, [
              _createVNode(_component_router_link, {
                class: "cursor-pointer",
                to: {name: 'transaksi-barang-diterima-detail', params: { id: item.Id }}
              }, {
                default: _withCtx(() => [
                  item
                    ? (_openBlock(), _createBlock(_component_ItemReceiptCard, {
                        key: 0,
                        data: item,
                        class: "w-full"
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          (_ctx.data.length > 0)
            ? (_openBlock(), _createBlock(_component_Paginator, {
                key: 0,
                rows: _ctx.filters.top,
                totalRecords: _ctx.filters.totalRecords,
                onPage: _ctx.onPage
              }, null, 8, ["rows", "totalRecords", "onPage"]))
            : _createCommentVNode("", true)
        ]))
      : (_ctx.onLoad)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
    _createVNode("div", _hoisted_11, [
      (_ctx.$store.state.device.isMobile || true)
        ? (_openBlock(), _createBlock("svg", {
            key: 0,
            xmlns: "http://www.w3.org/2000/svg",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'barcode' }))),
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            "aria-hidden": "true",
            focusable: "false",
            class: "w-10 h-10",
            style: {"-ms-transform":"rotate(360deg)","-webkit-transform":"rotate(360deg)","transform":"rotate(360deg)"},
            preserveAspectRatio: "xMidYMid meet",
            viewBox: "0 0 256 256"
          }, [
            _hoisted_12
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}